module.exports = __webpack_public_path__ + "img/volume.70d56429.svg";